import { render } from "./LastIncidents.vue?vue&type=template&id=4671009c&scoped=true"
import script from "./LastIncidents.vue?vue&type=script&lang=js"
export * from "./LastIncidents.vue?vue&type=script&lang=js"

import "./LastIncidents.vue?vue&type=style&index=0&id=4671009c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4671009c"]])

export default __exports__